var _g, _path, _ellipse, _ellipse2, _ellipse3, _path2, _path3, _path4, _path5, _rect, _rect2, _circle, _path6, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCreationProcess = function SvgCreationProcess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 229,
    height: 235,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#creation-process_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#355B98",
    d: "M21.5 8.017H209v139.296H21.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.27 113.614c.059-.34.1-.684.12-1.03l.487-34.315c0-.091-.136-.182-.273-.349-.259.197-.548.379-.791.591l-3.68 3.288a9.434 9.434 0 0 1-.944.803 1.952 1.952 0 0 1-2.737-.197 1.86 1.86 0 0 1 0-2.56c.353-.391.735-.755 1.14-1.091l29.551-26.499c1.095-.984 2.175-1.97 3.285-2.939a9.16 9.16 0 0 1 .943-.788 1.952 1.952 0 0 1 2.312-.09c.535.355 1.044.75 1.52 1.181l24.76 21.514 8.79 7.575c.406.336.787.7 1.141 1.09a1.873 1.873 0 0 1 .062 2.52 1.889 1.889 0 0 1-2.51.314 7.562 7.562 0 0 1-.974-.758c-.973-.833-1.946-1.696-2.935-2.53a6.493 6.493 0 0 0-.821-.484c-.058.27-.098.543-.122.818v33.921c.41.097.827.163 1.247.197h5.475c.511.001 1.02.052 1.521.152a1.88 1.88 0 0 1 1.658 1.681 1.851 1.851 0 0 1-1.11 1.834c-.38.151-.78.247-1.187.288h-1.414l-71.708-.288c-.471.037-.944.037-1.415 0a1.907 1.907 0 0 1-1.186-.627 1.89 1.89 0 0 1 1.186-3.131 6.85 6.85 0 0 1 1.232 0h7.437l-.06-.091Zm54.537-38.497-.456-.363-24.79-21.514c-.288-.218-.588-.42-.897-.606L89.877 73.966c-.182 13.12-.365 26.134-.532 39.149a.642.642 0 0 0 .152.303c2.155.287 4.34.287 6.494 0 .16-.608.207-1.24.137-1.864V93.071c0-1.97.654-2.606 2.631-2.621l13.414-.106h1.521a2.028 2.028 0 0 1 2.036 1.199c.113.257.17.535.169.816v19.286a2.854 2.854 0 0 0 .289 1.939H137.678a2.658 2.658 0 0 0 1.916-.333l.213-38.134Zm-27.786 38.361c.065-.442.105-.887.122-1.333V95.813c0-.5.167-1.06-.335-1.515a2.843 2.843 0 0 0-.517 0c-3.407 0-6.813 0-10.235.121a3.413 3.413 0 0 0-.822.197c-.057.25-.097.503-.121.757v17.408c.029.263.085.522.167.773 3.912.215 7.833.19 11.741-.076Z",
    fill: "#E7EBF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.806 41.865c-.522.452-.954.814-1.387 1.206L77.331 75.574a5.302 5.302 0 0 1-1.089.844 1.891 1.891 0 0 1-2.296-.422 1.851 1.851 0 0 1 0-2.412c.334-.4.703-.769 1.103-1.1l13.332-12.061c.18-.151.373-.287.582-.438v-2.668c0-3.558.09-7.13.119-10.688a11.06 11.06 0 0 0-.09-1.508 1.995 1.995 0 0 1 .48-1.626 1.953 1.953 0 0 1 1.549-.65c1.61 0 3.22.12 4.831.135h2.983c1.566-.105 2.326.634 2.311 2.277v3.286c.567.226.791-.21 1.059-.467 3.296-2.94 6.562-5.895 9.842-8.834.415-.405.858-.778 1.328-1.116a2.484 2.484 0 0 1 3.34.211 362.645 362.645 0 0 1 6.621 5.91l31.838 28.462c.485.407.939.85 1.358 1.327a1.878 1.878 0 0 1 .406 1.722 1.87 1.87 0 0 1-.437.8c-.209.225-.47.394-.76.493a1.683 1.683 0 0 1-1.64-.241c-.474-.333-.923-.7-1.342-1.1L116.67 43.477a51.586 51.586 0 0 0-1.864-1.613Zm-21.727 4.93c-.1.215-.17.443-.21.678 0 2.744-.089 5.472-.104 8.216 0 .12.18.241.358.452 1.238-1.13 2.446-2.2 3.624-3.316.24-.241.383-.564.403-.905a38.09 38.09 0 0 0 0-4.703 1.857 1.857 0 0 0-.507-.242c-1.193-.045-2.342-.045-3.564-.18Z",
    fill: "#E7EBF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139 75.22v37.64a2.6 2.6 0 0 1-1.879.327H116.047a2.806 2.806 0 0 1-.283-1.904V92.344a1.988 1.988 0 0 0-.643-1.466 1.986 1.986 0 0 0-1.52-.512h-1.491l-13.378-.06c-1.939 0-2.58.64-2.58 2.574v18.15a5.018 5.018 0 0 1-.135 1.83 23.99 23.99 0 0 1-6.368 0 .626.626 0 0 1-.149-.297c.164-12.78.343-25.56.522-38.443l23.341-21.007c.303.182.597.381.88.595l24.265 21.126.492.387Zm-25.13 7.052a7.017 7.017 0 0 0 4.923-1.984 6.983 6.983 0 0 0 2.116-4.86 6.314 6.314 0 0 0-1.814-4.443 6.346 6.346 0 0 0-4.42-1.894 6.959 6.959 0 0 0-4.953 1.92 6.925 6.925 0 0 0-2.146 4.85 6.136 6.136 0 0 0 3.831 5.96 6.173 6.173 0 0 0 2.463.451Z",
    fill: "#728CB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.913 113.062a96.706 96.706 0 0 1-11.746 0 3.687 3.687 0 0 1-.167-.756V95.265c.024-.25.064-.497.121-.742.263-.097.538-.162.817-.192 3.406 0 6.797-.09 10.188-.119.171-.015.343-.015.514 0 .5.4.333.95.333 1.483v15.988c.007.461-.013.921-.06 1.379ZM92.361 46.6c1.235 0 2.394.101 3.554.174.181.052.354.13.512.233a35.105 35.105 0 0 1 0 4.538c-.02.33-.165.64-.407.873-1.19 1.077-2.409 2.11-3.659 3.2-.18-.203-.361-.32-.361-.436 0-2.648 0-5.28.105-7.928.054-.229.14-.45.256-.655Z",
    fill: "#355B98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.875 82.674a6.162 6.162 0 0 1-2.488-.463 6.225 6.225 0 0 1-2.102-1.426 6.32 6.32 0 0 1-1.369-2.154 6.39 6.39 0 0 1-.411-2.528 7.166 7.166 0 0 1 2.172-4.982 6.986 6.986 0 0 1 5.013-1.972 6.381 6.381 0 0 1 4.469 1.94A6.54 6.54 0 0 1 121 75.644a7.23 7.23 0 0 1-2.141 4.991 7.051 7.051 0 0 1-4.984 2.04Zm3.231-7.03a2.587 2.587 0 0 0-.845-1.954 2.54 2.54 0 0 0-2.008-.644 3.23 3.23 0 0 0-1.924.94 3.303 3.303 0 0 0-.929 1.948c-.065.62.099 1.241.462 1.744.363.503.898.851 1.5.977a3.178 3.178 0 0 0 2.534-.661 3.257 3.257 0 0 0 1.21-2.35Z",
    fill: "#E7EBF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.5 75.152a3.24 3.24 0 0 1-.331 1.283c-.198.398-.476.75-.816 1.03-.341.281-.735.485-1.158.598a3.023 3.023 0 0 1-1.295.06 2.377 2.377 0 0 1-1.442-.95 2.48 2.48 0 0 1-.445-1.694 3.227 3.227 0 0 1 .894-1.892 3.093 3.093 0 0 1 1.85-.915 2.4 2.4 0 0 1 1.021.097c.33.105.634.28.893.515.259.234.467.521.61.843.143.323.217.672.219 1.025Z",
    fill: "#355B98"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 45.5,
    r: 22.5,
    fill: "#749282"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.97 53.022c-.507-1.158-2.955-1.93-4.588-2.647-1.632-.717-1.411-1.158-1.466-1.754-.012-.077-.012-.165-.012-.254.563-.496 1.015-1.18 1.313-1.963 0 0 .011-.044.022-.055.066-.165.121-.353.165-.53.375-.077.596-.485.673-.86a1.77 1.77 0 0 0 .22-.96c-.054-.55-.275-.804-.518-.904v-.099c0-.695-.066-1.71-.187-2.371a4.049 4.049 0 0 0-1.533-2.603c-.706-.518-1.688-.805-2.559-.805-.871 0-1.853.276-2.548.805a4.095 4.095 0 0 0-1.412 2.051c-.055.188-.099.364-.12.552-.133.662-.188 1.665-.188 2.371v.088c-.265.1-.497.353-.552.916-.033.419.144.794.22.948.089.386.31.794.696.86.044.188.099.365.165.541 0 .011.011.022.011.033l.011.011c.298.794.772 1.49 1.346 1.986 0 .077-.011.154-.011.231-.055.596.11 1.037-1.511 1.754-1.633.717-4.081 1.489-4.589 2.647-.507 1.158-.297 1.842-.297 1.842h17.558c-.01.01.199-.673-.308-1.831Z",
    fill: "#F8FAF9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.5 147.313H209v75.16H21.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 201,
    cy: 113,
    r: 24,
    fill: "#749282"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.75 118a2.507 2.507 0 0 0-2.5 2.5c0 1.375 1.125 2.5 2.5 2.5s2.5-1.125 2.5-2.5-1.125-2.5-2.5-2.5Zm-.625-8.125a3.126 3.126 0 0 0 0 6.25 3.126 3.126 0 0 0 0-6.25Zm5.625-3.125h10c.688 0 1.25-.563 1.25-1.25 0-.688-.562-1.25-1.25-1.25h-10c-.688 0-1.25.562-1.25 1.25 0 .687.562 1.25 1.25 1.25Zm10 12.5h-10c-.688 0-1.25.562-1.25 1.25 0 .687.562 1.25 1.25 1.25h10c.688 0 1.25-.563 1.25-1.25 0-.688-.562-1.25-1.25-1.25Zm-15-16.25a2.507 2.507 0 0 0-2.5 2.5c0 1.375 1.125 2.5 2.5 2.5s2.5-1.125 2.5-2.5-1.125-2.5-2.5-2.5Zm15 7.5h-10c-.688 0-1.25.562-1.25 1.25v2.5c0 .687.562 1.25 1.25 1.25h10c.688 0 1.25-.563 1.25-1.25v-2.5c0-.688-.562-1.25-1.25-1.25Z",
    fill: "#F8FAF9"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M21.5 0H209v8.017H21.5z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.5,
    cy: 4.009,
    rx: 2,
    ry: 2.004,
    fill: "#E8EAEA"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.5,
    cy: 4.009,
    rx: 2,
    ry: 2.004,
    fill: "#E8EAEA"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 35.5,
    cy: 4.009,
    rx: 2,
    ry: 2.004,
    fill: "#E8EAEA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E8EAEA",
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M62.5 183.894h126"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 180.384c-.28 0-.53.11-.71.29l-4.29 4.31-2.29-2.305a1.004 1.004 0 0 0-1.71.711c0 .281.11.531.29.712l3 3.006c.18.18.43.291.71.291.28 0 .53-.111.71-.291l5-5.011a1.004 1.004 0 0 0-.71-1.713Z",
    fill: "#E8EAEA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E8EAEA",
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "M62.5 202.434h126"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53 198.579a.98.98 0 0 0-.71.299L48 203.322l-2.29-2.377a.98.98 0 0 0-.71-.299c-.55 0-1 .465-1 1.033 0 .289.11.548.29.734l3 3.1c.18.186.43.3.71.3.28 0 .53-.114.71-.3l5-5.167c.18-.186.29-.444.29-.734 0-.568-.45-1.033-1-1.033Z",
    fill: "#E8EAEA"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 158.337,
    width: 154.5,
    height: 8.518,
    rx: 4.259,
    fill: "#E7EBF3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 158.337,
    width: 120.5,
    height: 8.518,
    rx: 4.259,
    fill: "#355B98"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 210,
    r: 22,
    fill: "#749282"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.146 200.833H22.27a1.15 1.15 0 0 0-1.146 1.146v16.042c0 .63.516 1.146 1.146 1.146h11.458a1.15 1.15 0 0 0 1.146-1.146v-11.459l-5.73-5.729Zm3.437 16.042h-9.166v-13.75H28v4.583h4.583v9.167Z",
    fill: "#F8FAF9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "creation-process_svg__a",
    x: 0,
    y: 8.017,
    width: 229,
    height: 222.456,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7072_144065"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7072_144065",
    result: "shape"
  })))));
};
export default SvgCreationProcess;